const offersTicker = $('#offersTickerContent');

if (offersTicker.length) {
    offersTicker.slick({
        dots: false,
        arrows: true,
        prevArrow: '<i class="fa offersTicker__arrows offersTicker__arrowLeft fa-chevron-left"></i>',
        nextArrow: '<i class="fa offersTicker__arrows offersTicker__arrowRight fa-chevron-right"></i>',
        adaptiveHeight: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000
    });
}
